import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import { JobNames } from '../../framework.core/JobNames';
import _ from 'lodash';

export class CrDbListItem extends SearchModelBase {
    invoiceDate: string | null = null;
    fromInvoiceDate: string | null = null;
    toInvoiceDate: string | null = null;
    crDbNo: string = '';
    agent: string = '';
    branch: string = '';
    etd: string | null = null;
    fromETD: string | null = null;
    toETD: string | null = null;
    eta: string | null = null;
    fromETA: string | null = null;
    toETA: string | null = null;
    currency: string = '';
    total: number|null = null;
    fromTotal: number|null = null;
    toTotal: number|null = null;
    paidAmt: number|null = null;
    fromPaidAmt: number|null = null;
    toPaidAmt: number|null = null;
    balance: number|null = null;
    fromBalance: number|null = null;
    toBalance: number|null = null;
    dutyAmount: number|null = null;
    fromDutyAmount: number|null = null;
    toDutyAmount: number|null = null;
    checkNo: string = '';
    paidDate: string | null = null;
    fromPaidDate: string | null = null;
    toPaidDate: string | null = null;
    lastClearDate: string | null = null;
    fromLastClearDate: string | null = null;
    toLastClearDate: string | null = null;
    blNo: string = '';
    refNo: string = '';
    yourRef: string = '';
    sRefNo: string = '';
    jobType: string = '';
    createBy: string = '';
    tbName: string = '';
    tbId: number = 0;
    id: number = 0;
    u1Date: string | null = null;
    u2ID: string = '';
    u2Date: string | null = null;
    postDate: string | null = null;
    period: string = '';
    settled : boolean = false;
    draftPaid: boolean = false;
    
    // cloud
    status: string = '';
    recognized: string = '';
    draft: boolean = false;
    mblNo: string = '';
    hblNo: string = '';
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    agentId: number = 0;
    creditTotal: number|null = null;
    toCreditTotal: number|null = null;
    fromCreditTotal: number|null = null;
    debitTotal: number|null = null
    toDebitTotal: number|null = null
    fromDebitTotal: number|null = null
    customer: string = '';
    mblId: number = 0;
    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;
    profitShareField : boolean = false;

    private static CrDbExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'R.Date', width: 80, dataIndex: 'confirmDate', hiddenInColumnSetup: true, type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 2, text: 'D', width: 30, dataIndex: 'draft', type: XCol.XCellType.Bool, noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        // XCol.Create({ col: 3, text: 'Void', width: 35, dataIndex: 'void', type: XCol.XCellType.StrBool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 3, text: 'Date', width: 75, dataIndex: 'invoiceDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Crdb #', width: 100, dataIndex: 'crDbNo', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'Agent', width: 150, dataIndex: 'agent'}),
        XCol.Create({ col: 7, text: 'Customer', width: 150, dataIndex: 'customer'}),
        XCol.Create({ col: 8, text: 'Agent Ref. #', width: 100, dataIndex: 'yourRef', visible: false}),
        XCol.Create({ col: 9, text: 'CUR', width: 40, dataIndex: 'currency', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Debit Amount', width: 100, dataIndex: 'debitTotal', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 11, text: 'Credit Amount', width: 100, dataIndex: 'creditTotal', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 12, text: 'Amount', width: 100, dataIndex: 'total', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 13, text: 'Paid', width: 100, dataIndex: 'paidAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 14, text: 'Balance', width: 100, dataIndex: 'balance', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 15, text: 'Confirmed', width: 60, dataIndex: 'settled', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 16, text: 'Duty Amt', width: 100, dataIndex: 'dutyAmount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00'}),
        XCol.Create({ col: 17, text: 'Draft Paid', width: 60, dataIndex: 'draftPaid', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: false}),
        XCol.Create({ col: 18, text: 'Check #', width: 80, dataIndex: 'checkNo'}),
        XCol.Create({ col: 19, text: 'Paid Date', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 20, text: 'Clear Date', width: 75, dataIndex: 'lastClearDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 21, text: 'PS', width: 40, dataIndex: 'profitShareField', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 22, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 23, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 24, text: 'Type', width: 40, dataIndex: 'jobType', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 25, text: 'Ref. #', width: 100, dataIndex: 'refNo'}),
        XCol.Create({ col: 26, text: 'MBL/MAWB #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 27, text: 'HBL/HAWB #', width: 100, dataIndex: 'hblNo'}),
        XCol.Create({ col: 28, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 29, text: 'Create by', width: 80, dataIndex: 'createBy'}),
        XCol.Create({ col: 30, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 31, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];

    private static WHCrDbExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        // XCol.Create({ col: 1, text: 'R', width: 35, dataIndex: 'recognized', noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        XCol.Create({ col: 2, text: 'D', width: 30, dataIndex: 'draft', type: XCol.XCellType.Bool, noNullOrEmptySearch: true, hiddenInColumnSetup: true}),
        // XCol.Create({ col: 3, text: 'Void', width: 35, dataIndex: 'void', type: XCol.XCellType.StrBool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 4, text: 'P', width: 35, dataIndex: 'period', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 5, text: 'Date', width: 70, dataIndex: 'invoiceDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'CrDb #', width: 100, dataIndex: 'crDbNo', defaultColumnFocus : true}),
        XCol.Create({ col: 7, text: 'Agent', width: 150, dataIndex: 'agent'}),
        XCol.Create({ col: 8, text: 'Agent Ref. #', width: 100, dataIndex: 'yourRef'}),
        XCol.Create({ col: 9, text: 'CUR', width: 40, dataIndex: 'currency'}),
        XCol.Create({ col: 10, text: 'Debit Amount', width: 120, dataIndex: 'debitTotal', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', visible: false}),
        XCol.Create({ col: 11, text: 'Credit Amount', width: 120, dataIndex: 'creditTotal', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', visible: false}),
        XCol.Create({ col: 12, text: 'Amount', width: 100, dataIndex: 'total', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00'}),
        XCol.Create({ col: 13, text: 'Paid', width: 100, dataIndex: 'paidAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00'}),
        XCol.Create({ col: 14, text: 'Balance', width: 100, dataIndex: 'balance', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00'}),
        XCol.Create({ col: 15, text: 'Confirmed', width: 60, dataIndex: 'settled', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 16, text: 'Draft Paid', width: 60, dataIndex: 'draftPaid', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: false}),
        XCol.Create({ col: 17, text: 'Check #', width: 100, dataIndex: 'checkNo'}),
        XCol.Create({ col: 18, text: 'Paid Date', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 19, text: 'Clear Date', width: 75, dataIndex: 'lastClearDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 20, text: 'Type', width: 60, dataIndex: 'jobType', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 21, text: 'Receiving/Shipping ID', width: 140, dataIndex: 'refNo', noNullOrEmptySearch: true}),
        XCol.Create({ col: 22, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 23, text: 'Create by', width: 80, dataIndex: 'createBy'}),
        XCol.Create({ col: 24, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 25, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(jobName: JobNames, useBranch: boolean, usebillingsTabVersion1: boolean = false): XCol.XExportColumn[] {
        let returnCloumns;
        switch (jobName) {
            case JobNames.CrDb:
                returnCloumns = _.cloneDeep(this.CrDbExportCollection)
                break;
            case JobNames.WHCrDb:
                returnCloumns = _.cloneDeep(this.WHCrDbExportCollection)
                break;
            default:
                returnCloumns = _.cloneDeep(this.CrDbExportCollection)
                break;
        }

        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        if (usebillingsTabVersion1) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'draft');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: CrDbListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: CrDbListItem[]) {
        return data.map((d: CrDbListItem) => ({
          ...d
        }));
    }


    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        invoiceDate: {from: 'fromInvoiceDate', to: 'toInvoiceDate'},
        etd: {from: 'fromETD', to: 'toETD'},
        eta: {from: 'fromETA', to: 'toETA'},
        total: {from: 'fromTotal', to: 'toTotal'},
        paidAmt: {from: 'fromPaidAmt', to: 'toPaidAmt'},
        balance: {from: 'fromBalance', to: 'toBalance'},
        dutyAmount: {from: 'fromDutyAmount', to: 'toDutyAmount'},
        paidDate: {from: 'fromPaidDate', to: 'toPaidDate'},
        lastClearDate: {from: 'fromLastClearDate', to: 'toLastClearDate'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        creditTotal: {from: 'fromCreditTotal', to: 'toCreditTotal'},
        debitTotal: {from: 'fromDebitTotal', to: 'toDebitTotal'},
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
    };
}
